// DUPLICATED — keep in sync with src/webform/components/ContentWrapper/contentWrapper.styled.ts (monolith).
// Can't be shared via path alias: a file under src/ resolves styled-components@5, while
// this workspace needs styled-components@6. Mirror every change on both sides until the
// monolith webform is decommissioned.
import {lightBorder, lightLayer} from "config/themeV2";
import styled from "styled-components";

export const ContentWrapper = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`;

export const Content = styled.div<{$fullHeight?: boolean}>`
    border: 1px solid ${lightBorder["neutral-secondary"]};
    border-top-width: 0;
    border-radius: 0 0 16px 16px;
    max-width: 506px;
    width: 100%;
    margin: 0 auto;
    padding: 24px;
    overflow: auto;
    background-color: ${lightLayer["floor-1"]};

    ${({$fullHeight}) =>
        $fullHeight &&
        `
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    `}

    @media (max-width: 500px) {
        border: 0;
    }
`;
